import { TextField } from "@mui/material";
import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import InvestorCommunicationContext from "../InvestorCommunicationContext";
import { setDescriptionAction, setTitleAction } from "../investorCommunicationEditState";

const InvestorCommunicationContentFormFields = () => {
  const { state, setState, isSaving, validationErrors } = useDefinedContext(
    InvestorCommunicationContext,
    "InvestorCommunicationContext"
  );

  return (
    <>
      <TextField
        label="Title"
        required
        fullWidth
        disabled={isSaving}
        value={state.title}
        error={validationErrors.title !== undefined}
        onChange={(e) => setState(setTitleAction(e.target.value))}
      />

      <TextField
        label="Summary"
        fullWidth
        multiline
        minRows={3}
        disabled={isSaving}
        value={state.description}
        helperText="A short summary shown on the News widget for investors."
        onChange={(e) => setState(setDescriptionAction(e.target.value))}
      />
    </>
  );
};

export default InvestorCommunicationContentFormFields;
